import moment from "moment";
import { colors } from "../theme/colors.ts";

export const mailValidation = (email: string) => {
  const reg = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w\w+)+$/;
  if (reg.test(email) === false) {
    return false;
  } else {
    return true;
  }
};

export const validatePhone = (phone: string) => {
  const reg = /^(\d{10}|\d{12})$/;
  if (reg.test(phone) === false) {
    return false;
  } else {
    return true;
  }
};

export const formatText = (text: string) => {
  return text.replace(/[^+\d]/g, "");
};

export const logout = (props: any) => {
  return props.navigation.navigate("SignIn");
};

export const ONE_SECOND_IN_MS = 1000;
export const VIBRATION_PATTERN = [
  0.25 * ONE_SECOND_IN_MS,
  0.25 * ONE_SECOND_IN_MS,
  0.25 * ONE_SECOND_IN_MS,
];

export const getStatusColor = (color: string) => {
  switch (color) {
    case "inactive":
      return colors.gray; // Green
    case "incomingrequest":
      return colors.paramedic.blue;

    case "requestride":
      return getRandomColor();

    case "arrived":
      return getRandomColor();

    case "enroute":
      return getRandomColor();

    case "active":
      return colors.secondary;
    default:
      return "#FFFFFF"; // White
  }
};

export const logDev = (...value: any) => {
  if (__DEV__) {
    console.log(value);
  }
};

export const __DEV__ = process.env.NODE_ENV !== "production" ? true : false;

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const formatDate = (date: string) => {
  return moment(date).format("YYYY-MM-DD HH:mm:ss");
};

export const getRandomColor = (): string => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const currentTime = () => {
  const timer = setInterval(() => {
    return moment().format("HH:mm:ss");
  }, 1000);

  return () => clearInterval(timer);
};

// export const base64ToBlob = async (base64: string): Promise<Blob> => {
//   const res = await fetch(base64);
//   return await res.blob();
// };
export const base64ToBlob = (base64: string): Blob => {
  const parts = base64.split(",");
  const mimeMatch = parts[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : "image/jpeg";

  const byteString = atob(parts[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mime });
};

export const loggedInUserId = () => {
  const userData = JSON.parse(localStorage.getItem("loggedInUser"));
  const id = userData?.user.id;
  return id;
};

export function formatCurrency(number: number, currency = "UGX") {
  if (isNaN(number)) return "";
  return `${currency} ${Number(number).toLocaleString("en-US")}`;
}

export function fancyTime(seconds: number) {
  if (isNaN(seconds) || seconds < 0) return "";

  if (seconds < 60) return `${seconds} second${seconds !== 1 ? "s" : ""}`;
  if (seconds < 600)
    return `${Math.floor(seconds / 60)} minute${
      Math.floor(seconds / 60) !== 1 ? "s" : ""
    }`;
  if (seconds < 3600) return `~${Math.round(seconds / 60)} minutes`;
  if (seconds < 7200) return `about an hour`;
  if (seconds < 86400)
    return `${Math.floor(seconds / 3600)} hour${
      Math.floor(seconds / 3600) !== 1 ? "s" : ""
    }`;

  const days = Math.floor(seconds / 86400);
  return `${days} day${days !== 1 ? "s" : ""} or more`;
}
